import {
  CANCEL_PUBLISH,
  CONFIRM_PUBLISH,
  PUBLISHING,
  PUBLISH_FAIL,
  PUBLISH_SUCCESS,
  START_PUBLISH,
} from "packages/online_ordering/actions/publish_status";

export const initialPublishStatusState = {
  status: "NOT_STARTED",
};

function publishStatus(state = initialPublishStatusState, action) {
  switch (action.type) {
    case START_PUBLISH:
    case CONFIRM_PUBLISH:
    case PUBLISHING:
    case PUBLISH_SUCCESS:
    case PUBLISH_FAIL:
      return {
        ...state,
        status: action.type,
      };

    case CANCEL_PUBLISH:
      return {
        status: "NOT_STARTED",
      };

    default:
      return state;
  }
}

export default publishStatus;
